// import React, { useEffect, useState } from 'react';
// import { useNavigate } from 'react-router';
// import {
//   Box,
//   Grid,
//   Select,
//   MenuItem,
//   Button,
//   DialogActions,
//   Dialog,
//   DialogTitle,
//   DialogContent,
//   DialogContentText,
//   IconButton,
//   CircularProgress,
//   Typography,
//   InputAdornment,
//   TextField,
// } from '@mui/material';
// import { MdDelete } from "react-icons/md";
// import { FaRegEdit } from "react-icons/fa";
// import { AiOutlineInfoCircle } from "react-icons/ai";
// import { Add, Remove } from '@mui/icons-material';

// const SingleProduct = ({ data, onDelete, onUpdate, addConsumeableProductCount,activeBranchId ,getData}) => {
//   const [selectItemId, setSelectItemId] = useState('');
//   const [openDialogue, setOpenDialogue] = useState(false);
//   const [loading, setLoading] = useState(false);
//   const [openDeleteDialog, setOpenDeleteDialog] = useState(false);
//   const [deleteId, setDeleteId] = useState(null);
//   const [deleteLoading, setDeleteLoading] = useState(false);
//   const [loadingProductId, setLoadingProductId] = useState('');
//   const [productDetails, setProductDetails] = useState(null);
//   const [open, setOpen] = useState(false);
//   const [updateCount, setUpdateCount] = useState({});
//   const [productData, setProductData] = useState({
//      consumeableProductName: '',
//     productVolume: '',
//     productUnit: 'ml',
//     consumeableProductCount: '',
//     remainingProductVolume: '',
//     remainingProductUnit: 'ml',
//     mappedProduct: [],
//   });
//  const navigate = useNavigate();


// //   const handleDetails = (product) => {
// //     setProductDetails(product);
// //     setOpen(true);
// //   };
//    const handleDetails = (id) => {

//     navigate(`/singleproduct/${id}`);
//   };

//   const handleClose = () => {
//     setOpen(false);
//     setProductDetails(null);
//   };

//   const handleUpdate = (item) => {
//     if (!item) return;
//     setSelectItemId(item._id);
//     setProductData({
//       consumeableProductName: item.consumeableProductName,
//       productVolume: item.productVolume,
//       productUnit: item.productUnit,
//       consumeableProductCount: item.consumeableProductCount,
//       mappedProduct:item.mappedProduct,
//       remainingProductVolume:item.remainingProductVolume,
//       remainingProductUnit:item.remainingProductUnit
//     });
//     setOpenDialogue(true);
//   };

//   const handleChange = (e) => {
//     const { name, value } = e.target;
//     setProductData(prev => ({
//       ...prev,
//       [name]: value
//     }));
//   };

//   const handleCloseDialogue = () => {
//     setOpenDialogue(false);
//   };

//   const handleUpdateProductData = async () => {
//     try {
//       setLoading(true);
//       await onUpdate(selectItemId, productData);
//       setOpenDialogue(false);
//     } catch (error) {
//       console.error('Error updating product:', error);
//     } finally {
//       setLoading(false);
//     }
//   };

//   const handleDeleteField = (id) => {
//     setDeleteId(id);
//     setOpenDeleteDialog(true);
//   };

//   const confirmDelete = async () => {
//     setDeleteLoading(true);
//     try {
//       await onDelete(deleteId);
//       setOpenDeleteDialog(false);
//     } catch (error) {
//       console.error('Error deleting product:', error);
//     } finally {
//       setDeleteLoading(false);
//     }
//   };

//   const handleCloseDeleteDialog = () => {
//     setOpenDeleteDialog(false);
//     setDeleteId(null);
//   };

// //   const handleAllCheckboxChange = () => {
// //     if (isAllChecked) {
// //       setCheckedProducts([]);
// //     } else {
// //       setCheckedProducts([...data]);
// //     }
// //     setIsAllChecked(!isAllChecked);
// //   };

// //   const handleSingleCheckboxChange = (productId) => {
// //     if (checkedProducts.some((check) => check._id === productId)) {
// //       setCheckedProducts((prev) => prev.filter((check) => check._id !== productId));
// //     } else {
// //       const checked = data.find((item) => item._id === productId);
// //       if (checked) {
// //         setCheckedProducts((prev) => [...prev, checked]);
// //       }
// //     }
// //   };

// //   useEffect(() => {
// //     setIsAllChecked(data?.length > 0 && checkedProducts?.length === data?.length);
// //   }, [checkedProducts, data]);

//   const handleCountChange = (productId, e) => {
//     const { value } = e.target;
//     setUpdateCount(prev => ({
//       ...prev,
//       [productId]: value
//     }));
//   };

//   const handleCountButton = async (item) => {
//     const updatedCount = updateCount[item._id];
//     if (!updatedCount || isNaN(updatedCount)) {
//       console.error('Please enter a valid count');
//       return;
//     }

//     try {
//       setLoadingProductId(item._id);
//       setLoading(true);
//       await addConsumeableProductCount(item._id, {productCount:parseInt(updatedCount)},activeBranchId);
//       getData()
//       setUpdateCount(prev => {
//         const newState = {...prev};
//         delete newState[item._id];
//         return newState;
//       });
//     } catch (error) {
//       console.error('Error adding count:', error);
//     } finally {
//       setLoading(false);
//       setLoadingProductId('');
//     }
//   };

// //   const CheckboxInputs = ({ type, isAllChecked, handleAllCheckboxChange, handleSingleCheckboxChange, checkedItems, fieldId }) => {
// //     if (type === 'Heading') {
// //       return (
// //         <input
// //           type="checkbox"
// //           checked={isAllChecked}
// //           onChange={handleAllCheckboxChange}
// //         />
// //       );
// //     } else {
// //       return (
// //         <input
// //           type="checkbox"
// //           checked={checkedItems.some(item => item._id === fieldId)}
// //           onChange={() => handleSingleCheckboxChange(fieldId)}
// //         />
// //       );
// //     }
// //   };

// console.log(data,'dataaaaaa')

//   return (
//     <Box sx={{ overflow: 'auto', width: '100%' }}>
//       <table className="table-container mt-3" style={{ width: '100%', tableLayout: 'fixed' }}>
//         <thead className="table-thead">
//           <tr>
//             {/* <th style={{ width: '50px', padding: '8px' }}>
//               <CheckboxInputs
//                 type={'Heading'}
//                 isAllChecked={isAllChecked}
//                 handleAllCheckboxChange={handleAllCheckboxChange}
//               />
//             </th> */}
//             <th style={{ width: '150px', padding: '8px' }}>Product Name</th>
//             <th style={{ width: '100px', padding: '8px' }}>Volume</th>
//             <th style={{ width: '80px', padding: '8px' }}>Count</th>
//             <th style={{ width: '150px', padding: '8px' }}>Actions</th>
//             <th style={{ width: '200px', padding: '8px' }}>Increase Count</th>
//           </tr>
//         </thead>
//         <tbody className="table-tbody">
//           {data?.map((item) => (
//             <tr key={item._id}>

//               {/* <td style={{ width: '50px', padding: '8px' }}>
//                 <CheckboxInputs
//                   type={'content'}
//                   handleSingleCheckboxChange={handleSingleCheckboxChange}
//                   checkedItems={checkedProducts}
//                   fieldId={item?._id}
//                 />
//               </td> */}
//               <td style={{ width: '150px', padding: '8px', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
//                 {item?.consumeableProductName || 'N/A'}
//               </td>
//               <td style={{ width: '100px', padding: '8px' }}>{`${item?.remainingProductVolume || ''} ${item?.remainingProductUnit || ''}`}</td>
//               <td style={{ width: '80px', padding: '8px' }}>{item?.consumeableProductCount || 0}</td>
//               <td style={{ width: '150px', padding: '8px' }}>
//                 <Box sx={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
//                   <IconButton
//                     onClick={() => handleDetails(item._id)}
//                     color="primary"
//                     title="View Details"
//                     size="small"
//                   >
//                     <AiOutlineInfoCircle style={{ color: '#696969', fontSize: '1.1rem' }} />
//                   </IconButton>
//                   <IconButton
//                     onClick={() => handleUpdate(item._id)}
//                     color="secondary"
//                     title="Update"
//                     size="small"
//                   >
//                     <FaRegEdit style={{ color: '#696969', fontSize: '1rem' }} />
//                   </IconButton>
//                   <IconButton
//                     onClick={() => handleDeleteField(item._id)}
//                     color="error"
//                     title="Delete"
//                     size="small"
//                   >
//                     <MdDelete color='#FF4D4D' style={{ fontSize: '1.2rem' }} />
//                   </IconButton>
//                 </Box>
//               </td>
//               <td style={{ width: '200px', padding: '8px' }}>
//                 <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
//                   <TextField
//                     type="number"
//                     value={updateCount[item._id] ?? ''}
//                     onChange={(e) => handleCountChange(item._id, e)}
//                     size="small"
//                     sx={{
//                       width: '120px',
//                       backgroundColor: item?.consumeableProductCount < 5 ? '#f5f5f5' : 'white',
//                       '& .MuiOutlinedInput-root': {
//                         paddingLeft: '4px',
//                         paddingRight: '4px',
//                       },
//                       '& input': {
//                         textAlign: 'center',
//                         padding: '8px 4px',
//                       },
//                     }}
//                     InputProps={{
//                       startAdornment: (
//                         <InputAdornment position="start">
//                           <IconButton
//                             size="small"
//                             onClick={(e) => {
//                               e.preventDefault();
//                               e.stopPropagation();
//                               const currentValue = parseInt(updateCount[item._id] || 0);

//                                 handleCountChange(item._id, { target: { value: currentValue - 1 } });

//                             }}
//                           >
//                             <Remove fontSize="small" />
//                           </IconButton>
//                         </InputAdornment>
//                       ),
//                       endAdornment: (
//                         <InputAdornment position="end">
//                           <IconButton
//                             size="small"
//                             onClick={(e) => {
//                               e.preventDefault();
//                               e.stopPropagation();
//                               const currentValue = parseInt(updateCount[item._id] || 0);
//                               handleCountChange(item._id, { target: { value: currentValue + 1 } });
//                             }}
//                           >
//                             <Add fontSize="small" />
//                           </IconButton>
//                         </InputAdornment>
//                       ),
//                     }}
//                   />

//                   <Button
//                     variant="contained"
//                     size="small"
//                     onClick={() => handleCountButton(item)}
//                     // disabled={!updateCount[item._id] || parseInt(updateCount[item._id]) <= 0}
//                     sx={{
//                       minWidth: '60px',
//                       height: '40px',
//                       backgroundColor: item?.consumeableProductCount < 5 ? '#e0e0e0' : '#4CAF50',
//                       color: item?.consumeableProductCount < 5 ? '#757575' : 'white',
//                       '&:hover': {
//                         backgroundColor: item?.consumeableProductCount < 5 ? '#e0e0e0' : '#43A047',
//                       },
//                     }}
//                   >
//                     {loading && loadingProductId === item._id ? (
//                       <CircularProgress size={20} color="inherit" />
//                     ) : (
//                       'Add'
//                     )}
//                   </Button>
//                 </Box>
//               </td>
//             </tr>
//           ))}
//         </tbody>
//       </table>

//       {deleteLoading && (
//         <Box sx={{ display: 'flex', justifyContent: 'center', p: 3 }}>
//           <CircularProgress />
//         </Box>
//       )}

//       <Dialog open={openDeleteDialog} onClose={handleCloseDeleteDialog}>
//         <DialogTitle>Confirm Deletion</DialogTitle>
//         <DialogContent>
//           <DialogContentText>Are you sure you want to delete this product?</DialogContentText>
//         </DialogContent>
//         <DialogActions>
//           <Button onClick={handleCloseDeleteDialog} color="primary">
//             Cancel
//           </Button>
//           <Button onClick={confirmDelete} color="secondary">
//             Delete
//           </Button>
//         </DialogActions>
//       </Dialog>

//       {/* <Dialog open={open} onClose={handleClose} maxWidth="sm" fullWidth>
//         <DialogTitle>
//           <Typography variant="h5" style={{ fontWeight: 'bold', textAlign: 'center' }}>
//             Product Details
//           </Typography>
//         </DialogTitle>
//         <DialogContent style={{ padding: '20px' }}>
//           {productDetails ? (
//             <>
//               <Typography variant="h6" style={{ marginBottom: '10px' }}>
//                 Product Name: {productDetails.consumeableProductName || 'N/A'}
//               </Typography>
//               <Typography variant="body1" style={{ marginBottom: '10px' }}>
//                 Available Count: {productDetails.consumeableProductCount || 0}
//               </Typography>
//               <Typography variant="body1" style={{ marginBottom: '10px' }}>
//                 Volume: {productDetails.productVolume} {productDetails.productUnit}
//               </Typography>
//             </>
//           ) : (
//             <Typography variant="body2">Loading...</Typography>
//           )}
//         </DialogContent>
//         <DialogActions>
//           <Button
//             onClick={handleClose}
//             variant="contained"
//             color="primary"
//             style={{ margin: '10px auto' }}
//           >
//             Close
//           </Button>
//         </DialogActions>
//       </Dialog> */}

//       <Dialog open={openDialogue} onClose={handleCloseDialogue} maxWidth="md">
//         <DialogTitle>Product Details</DialogTitle>
//         <DialogContent>
//           <DialogContentText>Here you can update Product details.</DialogContentText>
//           <Box style={{ marginTop: '20px' }}>
//             <Grid container spacing={3} justify="center">
//               <Grid item xs={12} md={4}>
//                 <TextField
//                   label="Product Name"
//                   name="consumeableProductName"
//                   value={productData.consumeableProductName}
//                   onChange={handleChange}
//                   type="text"
//                   fullWidth
//                   margin="normal"
//                 />
//               </Grid>
//               <Grid item xs={12} md={4} container>
//                 <Grid item xs={12} container spacing={3} alignItems="center">
//                   <Grid item xs={12} md={6}>
//                     <TextField
//                       label="Volume"
//                       name="productVolume"
//                       value={productData.productVolume}
//                       onChange={handleChange}
//                       type="number"
//                       min={1}
//                       fullWidth
//                       margin="normal"
//                     />
//                   </Grid>
//                 </Grid>
//               </Grid>
//             </Grid>
//           </Box>

//           <Box style={{ marginTop: '20px' }}>
//             <Grid container spacing={3}>
//               <Grid item xs={12} md={3}>
//                 <Typography variant="subtitle1" gutterBottom>Unit</Typography>
//                 <Select
//                   name="productUnit"
//                   value={productData.productUnit}
//                   onChange={handleChange}
//                   fullWidth
//                 >
//                   {['ml', 'l', 'gm', 'kg'].map((type) => (
//                     <MenuItem key={type} value={type}>
//                       {type}
//                     </MenuItem>
//                   ))}
//                 </Select>
//               </Grid>
//               <Grid item xs={12} md={3}>
//                 <TextField
//                   label="Product Count"
//                   name="consumeableProductCount"
//                   value={productData.consumeableProductCount}
//                   onChange={handleChange}
//                   type="number"
//                   fullWidth
//                   margin="normal"
//                   disabled
//                 />
//               </Grid>
//             </Grid>
//           </Box>
//         </DialogContent>
//         <DialogActions>
//           {loading ? (
//             <Box sx={{ display: 'flex', justifyContent: 'center', p: 3 }}>
//               <CircularProgress />
//             </Box>
//           ) : (
//             <>
//               <div style={{ width: '200px', margin: '3rem auto' }}>
//                 <Button
//                   variant="contained"
//                   fullWidth
//                   color="primary"
//                   sx={{ background: '#6174DD' }}
//                   onClick={handleCloseDialogue}
//                 >
//                   Cancel
//                 </Button>
//               </div>
//               <div style={{ width: '200px', margin: '3rem auto' }}>
//                 <Button
//                   variant="contained"
//                   fullWidth
//                   color="primary"
//                   sx={{ background: '#6174DD' }}
//                   onClick={handleUpdateProductData}
//                 >
//                   Update
//                 </Button>
//               </div>
//             </>
//           )}
//         </DialogActions>
//       </Dialog>
//     </Box>
//   );
// };

// export default SingleProduct;

import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router';
import {
    Box,
    Grid,
    Select,
    MenuItem,
    Button,
    DialogActions,
    Dialog,
    DialogTitle,
    DialogContent,
    DialogContentText,
    IconButton,
    CircularProgress,
    Typography,
    InputAdornment,
    TextField,
    FormControl,
} from '@mui/material';
import { MdDelete } from "react-icons/md";
import { FaRegEdit } from "react-icons/fa";
import { AiOutlineInfoCircle } from "react-icons/ai";
import { Add, Remove } from '@mui/icons-material';
import { useMain } from '../hooks/useMain';
import { getHighlightedText } from 'src/utils/textUtils';

export const TrimData = (data) => {
  if (typeof data === 'string' && data.length > 20) {
    return data.substring(0, 20) + '...';
  }
  return data;
};

const SingleProduct = ({ data, getData, allConsumeproducts, isMasked , search}) => {
    const [selectItemId, setSelectItemId] = useState('');
    const [openDialogue, setOpenDialogue] = useState(false);
    const [loading, setLoading] = useState(false);
    const [openDeleteDialog, setOpenDeleteDialog] = useState(false);
    const [deleteId, setDeleteId] = useState(null);
    const [deleteLoading, setDeleteLoading] = useState(false);
    const [loadingProductId, setLoadingProductId] = useState('');
    const [productDetails, setProductDetails] = useState(null);
     const [hoveredItemId, setHoveredItemId] = useState(null);
    const [open, setOpen] = useState(false);
    const [updateCount, setUpdateCount] = useState({});
    const [productData, setProductData] = useState({
        consumeableProductName: '',
        productVolume: '',
        productUnit: 'ml',
        consumeableProductCount: '',
        remainingProductVolume: '',
        remainingProductUnit: 'ml',
    });
    const { updateConsumeableProduct, setShowMessage, activeBranchId, deleteConsumeableProduct, addConsumeableProductCount } = useMain();
    const navigate = useNavigate();


    //   const handleDetails = (product) => {
    //     setProductDetails(product);
    //     setOpen(true);
    //   };
    const handleDetails = (id) => {

        navigate(`/singleproduct/${id}`);
    };

    const handleClose = () => {
        setOpen(false);
        setProductDetails(null);
    };

    const handleUpdate = (item) => {
        if (!item) return;
        setSelectItemId(item._id);
        setProductData({
            consumeableProductName: item.consumeableProductName || '',
            productVolume: item.productVolume || '',
            productUnit: item.productUnit || 'ml',
            consumeableProductCount: Number(item.consumeableProductCount) || '',
            remainingProductVolume: item.remainingProductVolume || '',
            remainingProductUnit: item.remainingProductUnit || 'ml',
        });
        setOpenDialogue(true);
    };
    const handleChange = (e) => {
        const { name, value } = e.target;
        setProductData(prev => ({
            ...prev,
            [name]: value
        }));
    };
    // Remove only leading spaces while typing (spaces between words still work)
    const handleProductNameChange = (e) => {
        setProductData((prev) => ({ ...prev, consumeableProductName: e.target.value.trimStart() }));
    };

    // Trims the pasted text, then inserts it at the cursor position
    const handleProductNamePaste = (e) => {
        e.preventDefault();
        const pasted = e.clipboardData.getData('text').trim();
        const { selectionStart, selectionEnd, value } = e.target;
        const next = (value.slice(0, selectionStart) + pasted + value.slice(selectionEnd)).trim();
        setProductData((prev) => ({ ...prev, consumeableProductName: next }));
    };

    // Trims trailing spaces when the user leaves the box
    const handleProductNameBlur = (e) => {
        const trimmed = e.target.value.trim();
        if (trimmed !== e.target.value) {
            setProductData((prev) => ({ ...prev, consumeableProductName: trimmed }));
        }
    };

    const handleCloseDialogue = () => {
        setOpenDialogue(false);
    };

    const handleUpdateProductData = async () => {
        try {
            setLoading(true);
            // Convert numeric fields before sending
            const payload = {
              ...productData,
              consumeableProductName: (productData.consumeableProductName || '').trim(),
              consumeableProductCount:
                productData.consumeableProductCount === ''
                  ? 0
                  : Number(productData.consumeableProductCount),
              remainingProductVolume:
                productData.remainingProductVolume === ''
                  ? 0
                  : Number(productData.remainingProductVolume),
            };

            const res = await updateConsumeableProduct(selectItemId, payload, activeBranchId);

            if (res?.statusCode === 200) {
                setShowMessage({
                    message: res.message || 'Product updated successfully',
                    messageType: 'success',
                });
                getData();
                setOpenDialogue(false);
            } else {
                setShowMessage({
                    message: res?.message || 'Failed to update product',
                    messageType: 'error',
                });
            }
        } catch (error) {
            setShowMessage({
                message: error.message || 'Something went wrong while updating product',
                messageType: 'error',
            });
            console.error('Error updating product:', error);
        } finally {
            setLoading(false);
        }
    };


    const handleDeleteField = (id) => {
        setDeleteId(id);
        setOpenDeleteDialog(true);
    };

    const confirmDelete = async () => {
        setDeleteLoading(true);
        try {
            await deleteConsumeableProduct(deleteId, activeBranchId);
            getData()
            setOpenDeleteDialog(false);
        } catch (error) {
            console.error('Error deleting product:', error);
        } finally {
            setDeleteLoading(false);
        }
    };

    const handleCloseDeleteDialog = () => {
        setOpenDeleteDialog(false);
        setDeleteId(null);
    };

    //   const handleAllCheckboxChange = () => {
    //     if (isAllChecked) {
    //       setCheckedProducts([]);
    //     } else {
    //       setCheckedProducts([...data]);
    //     }
    //     setIsAllChecked(!isAllChecked);
    //   };

    //   const handleSingleCheckboxChange = (productId) => {
    //     if (checkedProducts.some((check) => check._id === productId)) {
    //       setCheckedProducts((prev) => prev.filter((check) => check._id !== productId));
    //     } else {
    //       const checked = data.find((item) => item._id === productId);
    //       if (checked) {
    //         setCheckedProducts((prev) => [...prev, checked]);
    //       }
    //     }
    //   };

    //   useEffect(() => {
    //     setIsAllChecked(data?.length > 0 && checkedProducts?.length === data?.length);
    //   }, [checkedProducts, data]);

    const handleCountChange = (productId, e) => {
        const { value } = e.target;
        setUpdateCount(prev => ({
            ...prev,
            [productId]: value
        }));
    };

    const handleCountButton = async (item) => {
        const updatedCount = updateCount[item._id];
        if (!updatedCount || isNaN(updatedCount)) {
            setShowMessage({
                message: 'Please enter a valid count',
                messageType: 'error',
            });
            return;
        }

        try {
            setLoadingProductId(item._id);
            setLoading(true);

            const res = await addConsumeableProductCount(
                item._id,
                { productCount: parseInt(updatedCount) },
                activeBranchId
            );

            if (res?.statusCode === 200) {
                setShowMessage({
                    message: res.message || 'Product count updated successfully',
                    messageType: 'success',
                });
                getData();
                setUpdateCount((prev) => {
                    const newState = { ...prev };
                    delete newState[item._id];
                    return newState;
                });
            } else {
                setShowMessage({
                    message: res?.message || 'Failed to update product count',
                    messageType: 'error',
                });
            }
        } catch (error) {
            setShowMessage({
                message: error.message || 'Something went wrong while updating count',
                messageType: 'error',
            });
            console.error('Error adding count:', error);
        } finally {
            setLoading(false);
            setLoadingProductId('');
        }
    };


    //   const CheckboxInputs = ({ type, isAllChecked, handleAllCheckboxChange, handleSingleCheckboxChange, checkedItems, fieldId }) => {
    //     if (type === 'Heading') {
    //       return (
    //         <input
    //           type="checkbox"
    //           checked={isAllChecked}
    //           onChange={handleAllCheckboxChange}
    //         />
    //       );
    //     } else {
    //       return (
    //         <input
    //           type="checkbox"
    //           checked={checkedItems.some(item => item._id === fieldId)}
    //           onChange={() => handleSingleCheckboxChange(fieldId)}
    //         />
    //       );
    //     }
    //   };

    const productGridTemplate = '250px 120px 100px 100px 120px 120px 190px';
const productGridRowStyle = {
  display: 'grid',
  gridTemplateColumns: productGridTemplate,
  alignItems: 'center',
  columnGap: '4px',
};
    return (
      <Box sx={{ overflow: 'auto', width: '100%' }}>
      <table className="table-container mt-3" style={{ width: '100%' }}>
          <thead className="table-thead">
            <tr style={productGridRowStyle}>
              <th style={{ padding: '4px', whiteSpace: 'nowrap' ,textAlign: 'center' }}>Product Name</th>
              <th style={{ padding: '4px', whiteSpace: 'nowrap' ,textAlign: 'center' }}>Remaining Volume</th>
              <th style={{ padding: '4px', whiteSpace: 'nowrap' ,textAlign: 'center' }}>Total Stock Count</th>
              <th style={{ padding: '4px', whiteSpace: 'nowrap' ,textAlign: 'center' }}>Quantity Used</th>
              <th style={{ padding: '4px', whiteSpace: 'nowrap' ,textAlign: 'center' }}>Count of Times Used</th>
              <th style={{ padding: '4px', whiteSpace: 'nowrap' ,textAlign: 'center' }}>Actions</th>
              <th style={{ padding: '4px', whiteSpace: 'nowrap' ,textAlign: 'center' }}>Increase Count</th>
            </tr>
          </thead>
          <tbody className="table-tbody">
          {data?.map((item) => (
              <tr key={item._id} style={productGridRowStyle}>
                <td style={{ padding: '4px', position: 'relative', textAlign: 'center', whiteSpace: 'normal', overflow: 'visible', textOverflow: 'clip' }}>
                  <div
                    onMouseEnter={() => setHoveredItemId(item._id + '_productName')}
                    onMouseLeave={() => setHoveredItemId(null)}
                    style={{ cursor: 'pointer' }}
                  >
                {getHighlightedText(TrimData(item?.consumeableProductName || 'N/A'), search)}
                    {hoveredItemId === item._id + '_productName' && (
                      <div
                        style={{
                          position: 'absolute',
                          top: '100%',
                          left: 0,
                          backgroundColor: '#dfe3f8',
                          border: '1px solid #ccc',
                          padding: '8px',
                          borderRadius: '5px',
                          zIndex: 5,
                          boxShadow: '0 2px 8px rgba(0,0,0,0.2)',
                          whiteSpace: 'pre-wrap',
                          maxWidth: '300px',
                        }}
                      >
                {getHighlightedText(TrimData(item?.consumeableProductName || 'N/A'), search)}
                      </div>
                    )}
                  </div>
                </td>
               <td style={{ padding: '4px', whiteSpace: 'nowrap' ,textAlign: 'center' }}>{`${
                  item?.remainingProductVolume || ''
                } ${item?.remainingProductUnit || ''}`}</td>
                <td style={{ padding: '4px', textAlign: 'center' }}>
                  {item?.consumeableProductCount || 0}
                </td>
                <td style={{ padding: '4px', textAlign: 'center' }}>{item?.totalQuantityUsed || 0}</td>
                <td style={{ padding: '4px', textAlign: 'center' }}>{item?.usedCount || 0}</td>
                <td style={{ padding: '4px', textAlign: 'center' }}>
                  <Box sx={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
                    <IconButton
                      onClick={() => handleDetails(item._id)}
                      color="primary"
                      title="View Details"
                      size="small"
                    >
                      <AiOutlineInfoCircle style={{ color: '#696969', fontSize: '1.1rem' }} />
                    </IconButton>
                    <IconButton
                      onClick={() => handleUpdate(item)} // Pass whole item, not just ID
                      color="secondary"
                      title="Update"
                      size="small"
                    >
                      <FaRegEdit style={{ color: '#696969', fontSize: '1rem' }} />
                    </IconButton>
                    <IconButton
                      onClick={() => handleDeleteField(item._id)}
                      color="error"
                      title="Delete"
                      size="small"
                    >
                      <MdDelete color="#FF4D4D" style={{ fontSize: '1.2rem' }} />
                    </IconButton>
                  </Box>
                </td>
                <td style={{ padding: '0px', textAlign: 'center' }}>
                  <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
                    <TextField
                      type="number"
                      value={updateCount[item._id] ?? ''}
                      onChange={(e) => handleCountChange(item._id, e)}
                      size="small"
                      sx={{
                        width: '110px',
                        backgroundColor: item?.consumeableProductCount < 5 ? '#f5f5f5' : 'white',
                        '& .MuiOutlinedInput-root': {
                          paddingLeft: '4px',
                          paddingRight: '4px',
                        },
                        '& input': {
                          textAlign: 'center',
                          padding: '8px 4px',
                        },
                      }}
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position="start">
                            <IconButton
                              size="small"
                              onClick={(e) => {
                                e.preventDefault();
                                e.stopPropagation();
                                const currentValue = parseInt(updateCount[item._id] || 0);

                                handleCountChange(item._id, {
                                  target: { value: currentValue - 1 },
                                });
                              }}
                            >
                              <Remove fontSize="small" />
                            </IconButton>
                          </InputAdornment>
                        ),
                        endAdornment: (
                          <InputAdornment position="end">
                            <IconButton
                              size="small"
                              onClick={(e) => {
                                e.preventDefault();
                                e.stopPropagation();
                                const currentValue = parseInt(updateCount[item._id] || 0);
                                handleCountChange(item._id, {
                                  target: { value: currentValue + 1 },
                                });
                              }}
                            >
                              <Add fontSize="small" />
                            </IconButton>
                          </InputAdornment>
                        ),
                      }}
                    />

                    <Button
                      variant="contained"
                      size="small"
                      onClick={() => handleCountButton(item)}
                      // disabled={!updateCount[item._id] || parseInt(updateCount[item._id]) <= 0}
                     sx={{
                        minWidth: '50px',
                        height: '36px',
                        backgroundColor: item?.consumeableProductCount < 5 ? '#e0e0e0' : '#4CAF50',
                        color: item?.consumeableProductCount < 5 ? '#757575' : 'white',
                        '&:hover': {
                          backgroundColor:
                            item?.consumeableProductCount < 5 ? '#e0e0e0' : '#43A047',
                        },
                      }}
                    >
                      {loading && loadingProductId === item._id ? (
                        <CircularProgress size={20} color="inherit" />
                      ) : (
                        'Add'
                      )}
                    </Button>
                  </Box>
                </td>
              </tr>
            ))}
          </tbody>
        </table>

        {deleteLoading && (
          <Box sx={{ display: 'flex', justifyContent: 'center', p: 3 }}>
            <CircularProgress />
          </Box>
        )}

        <Dialog open={openDeleteDialog} onClose={handleCloseDeleteDialog}>
          <DialogTitle>Confirm Deletion</DialogTitle>
          <DialogContent>
            <DialogContentText>Are you sure you want to delete this product?</DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={handleCloseDeleteDialog} color="primary">
              Cancel
            </Button>
            <Button onClick={confirmDelete} color="secondary">
              Delete
            </Button>
          </DialogActions>
        </Dialog>

        <Dialog open={openDialogue} onClose={handleCloseDialogue} maxWidth="sm" fullWidth>
          <DialogTitle>Product Details</DialogTitle>
          <DialogContent>
            <DialogContentText>Here you can update Product details.</DialogContentText>

            {/* First Row */}
              <Grid container spacing={3} sx={{ mt: 2 }}>
                <Grid item xs={12} md={6}>
                  <FormControl fullWidth>
                    <label style={{
                      fontSize: "15px",
                      fontWeight: 600,
                      marginBottom: "12px",
                      display: "block",
                      color: "#212529",
                      minHeight: '20px',
                    }}>Product Name</label>
                    <input
                      name="consumeableProductName"
                      placeholder="Product Name"
                      value={productData.consumeableProductName}
                      onChange={handleProductNameChange}
                      onPaste={handleProductNamePaste}
                      onBlur={handleProductNameBlur}
                      type="text"
                      style={{
                        border: '1px solid #ced4da',
                        borderRadius: '4px',
                        outline: 'none',
                        height: '57px',
                        padding: '12px',
                        fontSize: '16px',
                        background: 'transparent',
                        width: '100%',
                        boxSizing: 'border-box',
                      }}
                    />
                  </FormControl>
                </Grid>

                <Grid item xs={12} md={6}>
                  <FormControl fullWidth>
                    <label style={{
                      fontSize: "15px",
                      fontWeight: 600,
                      marginBottom: "12px",
                      display: "block",
                      color: "#212529",
                      minHeight: '20px',
                    }}>Volume</label>
                    <Box
                      sx={{
                        display: 'flex',
                        alignItems: 'center',
                        border: '1px solid #ced4da',
                        borderRadius: '4px',
                        height: "57px",
                        transition: 'border-color 0.2s ease-in-out',
                        '&:hover': {
                          borderColor: '#6174DD',
                        },
                      }}
                    >
                      <input
                        name="productVolume"
                        placeholder="0"
                        value={productData.productVolume}
                        onChange={handleChange}
                        type="number"
                        style={{
                          border: 'none',
                          outline: 'none',
                          flex: 1,
                          padding: '12px 12px',
                          fontSize: '16px',
                          background: 'transparent',
                          width: '100%'
                        }}
                      />
                      <Select
                        name="productUnit"
                        value={productData.productUnit}
                        onChange={handleChange}
                        disabled
                        displayEmpty
                        inputProps={{ 'aria-label': 'Without label' }}
                        sx={{
                          background: '#F0F0F0',
                          border: 'none',
                          height: '100%',
                          minWidth: '90px',
                          borderTopLeftRadius: '0px',
                          borderBottomLeftRadius: '0px',
                          borderTopRightRadius: '3px',
                          borderBottomRightRadius: '3px',
                          '& .MuiSelect-select': {
                            padding: '8px 16px',
                            paddingRight: '24px !important',
                            height: '100% !important',
                            display: 'flex',
                            alignItems: 'center'
                          },
                          '& .MuiOutlinedInput-notchedOutline': {
                            border: 'none'
                          },
                          borderLeft: '1px solid #ced4da'
                        }}
                      >
                        {['ml', 'l', 'gm', 'kg', 'pcs'].map((type) => (
                          <MenuItem key={type} value={type}>
                            {type}
                          </MenuItem>
                        ))}
                      </Select>
                    </Box>
                  </FormControl>
                </Grid>
              </Grid>

              {/* Second Row */}
              <Grid container spacing={3} sx={{ mt: 2 }}>
                <Grid item xs={12} md={6}>
                  <FormControl fullWidth>
                    <label style={{
                      fontSize: "15px",
                      fontWeight: 600,
                      marginBottom: "12px",
                      display: "block",
                      color: "#212529",
                      minHeight: '20px',
                    }}>Remaining Volume</label>
                    <Box
                      sx={{
                        display: 'flex',
                        alignItems: 'center',
                        border: '1px solid #ced4da',
                        borderRadius: '4px',
                        height: "57px",
                        transition: 'border-color 0.2s ease-in-out',
                        '&:hover': {
                          borderColor: '#6174DD',
                        },
                      }}
                    >
                      <input
                        name="remainingProductVolume"
                        placeholder="0"
                        value={productData.remainingProductVolume || 0}
                        onChange={handleChange}
                        type="number"
                        style={{
                          border: 'none',
                          outline: 'none',
                          flex: 1,
                          padding: '12px 12px',
                          fontSize: '16px',
                          background: 'transparent',
                          width: '100%'
                        }}
                      />
                      <Select
                        name="remainingProductUnit"
                        value={productData.remainingProductUnit}
                        onChange={handleChange}
                        disabled
                        displayEmpty
                        inputProps={{ 'aria-label': 'Without label' }}
                        sx={{
                          background: '#F0F0F0',
                          border: 'none',
                          height: '100%',
                          minWidth: '90px',
                          borderTopLeftRadius: '0px',
                          borderBottomLeftRadius: '0px',
                          borderTopRightRadius: '3px',
                          borderBottomRightRadius: '3px',
                          '& .MuiSelect-select': {
                            padding: '8px 16px',
                            paddingRight: '24px !important',
                            height: '100% !important',
                            display: 'flex',
                            alignItems: 'center'
                          },
                          '& .MuiOutlinedInput-notchedOutline': {
                            border: 'none'
                          },
                          borderLeft: '1px solid #ced4da'
                        }}
                      >
                        {['ml', 'l', 'gm', 'kg', 'pcs'].map((type) => (
                          <MenuItem key={type} value={type}>
                            {type}
                          </MenuItem>
                        ))}
                      </Select>
                    </Box>
                  </FormControl>
                </Grid>

                <Grid item xs={12} md={6}>
                  <FormControl fullWidth>
                    <label style={{
                      fontSize: "15px",
                      fontWeight: 600,
                      marginBottom: "12px",
                      display: "block",
                      color: "#212529",
                      minHeight: '20px',
                    }}>Product Count</label>
                    <input
                      name="consumeableProductCount"
                      placeholder="0"
                      value={productData.consumeableProductCount}
                      onChange={handleChange}
                      type="number"
                      disabled
                      style={{
                        border: '1px solid #ced4da',
                        borderRadius: '4px',
                        outline: 'none',
                        height: '57px',
                        padding: '12px',
                        fontSize: '16px',
                        background: '#f5f5f5',
                        width: '100%',
                        boxSizing: 'border-box',
                        color: '#666',
                      }}
                    />
                  </FormControl>
                </Grid>
</Grid>
          </DialogContent>

          <DialogActions>
            <Button onClick={handleCloseDialogue} variant="outlined">
              Cancel
            </Button>
            <Button onClick={handleUpdateProductData} variant="contained" color="primary">
              {loading ? <CircularProgress size={20} /> : 'Update'}
            </Button>
          </DialogActions>
        </Dialog>
      </Box>
    );
};

export default SingleProduct;